import React, { useMemo, useEffect } from "react";
import { useSharedState } from "../../context/formsContext";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";

import "./testBox.css";

import ChangingProgressProvider from "./ChangingProgressProvider";
import "react-circular-progressbar/dist/styles.css";
import { Pie } from "react-chartjs-2";
import testImage from "../../assets/Personalised_tests-01.png";
import CustomButton from "../customButton/customButton";
import "./testBox.css";
import { useNavigate } from "react-router-dom";
import mathsImage from "../../assets/MathsImg.png";
import englishImage from "../../assets/EnglishImg.png";
import VRImage from "../../assets/VRImg.png";
import NVRImage from "../../assets/NVRImg.png";
import { getProperty } from "../../utils/apiResponseHelper";

const TestBox = ({
  title,
  testProgress,
  className,
  index,
  pieData,
  paperImg,
  freePapers,
  type,
  isGcse,
  isMobile,
}) => {
  const { testData, setIndex, setBackKey } = useSharedState();

  Chart.register(ArcElement, Tooltip, Legend);

  const navigate = useNavigate();

  const newPercent = useMemo(() => {
    if (!testData || !testData[index]) return 0;
    const testItem = testData[index];
    const attempted = getProperty(testItem, 'totalAttempted') || getProperty(testItem, 'TotalAttempted') || testItem?.TotalAttempted || testItem?.totalAttempted || 0;
    const total = getProperty(testItem, 'totalQuestions') || getProperty(testItem, 'TotalQuestions') || testItem?.TotalQuestions || testItem?.totalQuestions || 1;
    return Math.round((attempted / total) * 100);
  }, [testData, index]);

  const boxText = useMemo(() => {
    if (!testData || !testData[index]) return "Not Started";
    const testItem = testData[index];
    const percent = newPercent;
    const startTime = getProperty(testItem, 'startTime') || getProperty(testItem, 'StartTime') || testItem?.StartTime || testItem?.startTime || '';
    const endTime = getProperty(testItem, 'endTime') || getProperty(testItem, 'EndTime') || testItem?.EndTime || testItem?.endTime || '';

    if (!startTime && !endTime) {
      return "Not Started";
    } else if (startTime && !endTime) {
      return `${percent}% Complete`;
    } else if (endTime) {
      return "100% Complete";
    } else {
      return "In Progress";
    }
  }, [testData, index, newPercent]);

  useEffect(() => {
    localStorage.removeItem("curriculumId");
    localStorage.removeItem("quizIndex");
    localStorage.removeItem("quizSummaryId");
    localStorage.removeItem("timeRemaining");
    localStorage.removeItem("totalQuestions");
    localStorage.removeItem("questionId");
  }, []);

  const buttonText = useMemo(() => {
    if (!testData || !testData[index]) return "Start Test";
    const testItem = testData[index];
    const startTime = getProperty(testItem, 'startTime') || getProperty(testItem, 'StartTime') || testItem?.StartTime || testItem?.startTime || '';
    const endTime = getProperty(testItem, 'endTime') || getProperty(testItem, 'EndTime') || testItem?.EndTime || testItem?.endTime || '';

    if (!startTime && !endTime) {
      return "Start Test";
    } else if (startTime && !endTime) {
      return "Continue";
    } else {
      return "Summary";
    }
  }, [testData, index]);

  const whichScreen = async (index) => {
    if (!testData || !testData[index]) {
      return;
    }
    
    const selectedTest = testData[index];
    const quizSummaryId = getProperty(selectedTest, 'quizSummaryId') || getProperty(selectedTest, 'QuizSummaryId') || selectedTest?.QuizSummaryId || selectedTest?.quizSummaryId;
    
    setIndex(index);
    localStorage.setItem("quizIndex", index);
    if (quizSummaryId) {
      localStorage.setItem("quizSummaryId", JSON.stringify(quizSummaryId));
    }

    try {
      if (selectedTest) {
        if (testProgress === "finished") {
          setBackKey((prevState) => !prevState);
          navigate("/quizScreen");
        } else if (testProgress === "notStarted") {
          navigate("/takeQuiz");
          setBackKey((prevState) => !prevState);
        } else {
          navigate("/takeQuiz");
          setBackKey((prevState) => !prevState);
        }
      } else {
      }
    } catch (error) {
    }
  };

  const getTestPaperColors = () => {
    if (type === "maths") {
      return "red-border";
    }
    if (type === "english") {
      return "blue-border";
    }
    if (type === "nonVerbal") {
      return "yellow-border";
    }
    if (type === "verbal") {
      return "green-border";
    }

    return "yellow-border";
  };



  const getTestPaperLinks = () => {
    // Use type prop to determine which PDF to open, as it's more reliable than image paths
    if (type === "maths") {
      window.open(
        "https://www.ksol.co.uk/contents/uploads/papers/11MathsPracticePaper1.pdf",
        "_blank",
        "noopener noreferrer"
      );
    } else if (type === "english") {
      window.open(
        "https://www.ksol.co.uk/contents/uploads/papers/11ComprehensionPracticePaper.pdf",
        "_blank",
        "noopener noreferrer"
      );
    } else if (type === "verbal") {
      window.open(
        "https://www.ksol.co.uk/contents/uploads/papers/11VerbalReasoning.pdf",
        "_blank",
        "noopener noreferrer"
      );
    } else if (type === "nonVerbal") {
      window.open(
        "https://www.ksol.co.uk/contents/uploads/papers/11NVR.pdf",
        "_blank",
        "noopener noreferrer"
      );
    } else {
      // Fallback: try to match by paperImg path or title if type is not available
      const paperImgStr = typeof paperImg === 'string' ? paperImg : '';
      const titleStr = typeof title === 'string' ? title.toLowerCase() : '';
      
      if (paperImgStr.includes("Maths-Paper-1") || titleStr.includes("maths paper 1")) {
        window.open(
          "https://www.ksol.co.uk/contents/uploads/papers/11MathsPracticePaper1.pdf",
          "_blank",
          "noopener noreferrer"
        );
      } else if (paperImgStr.includes("Maths-Paper-2") || titleStr.includes("maths paper 2")) {
        window.open(
          "https://www.ksol.co.uk/contents/uploads/papers/11MathsPracticePaper2.pdf",
          "_blank",
          "noopener noreferrer"
        );
      } else if (paperImgStr.includes("Comprehension") || titleStr.includes("comprehension") || titleStr.includes("english")) {
        window.open(
          "https://www.ksol.co.uk/contents/uploads/papers/11ComprehensionPracticePaper.pdf",
          "_blank",
          "noopener noreferrer"
        );
      } else if (paperImgStr.includes("NVR-Paper-Cover-1") || titleStr.includes("nvr") && !titleStr.includes("paper 2")) {
        window.open(
          "https://www.ksol.co.uk/contents/uploads/papers/11NVR.pdf",
          "_blank",
          "noopener noreferrer"
        );
      } else if (paperImgStr.includes("NVR-Paper-2") || titleStr.includes("nvr paper 2")) {
        window.open(
          "https://www.ksol.co.uk/contents/uploads/papers/11NVRPaper2.pdf",
          "_blank",
          "noopener noreferrer"
        );
      } else if (paperImgStr.includes("Verbal") || titleStr.includes("verbal")) {
        window.open(
          "https://www.ksol.co.uk/contents/uploads/papers/11VerbalReasoning.pdf",
          "_blank",
          "noopener noreferrer"
        );
      } else if (paperImgStr.includes("NVRSpatial") || titleStr.includes("spatial")) {
        window.open(
          "https://www.ksol.co.uk/contents/uploads/papers/11NVRGL.pdf",
          "_blank",
          "noopener noreferrer"
        );
      } else if (paperImgStr.includes("TechnicalEnglish") || titleStr.includes("technical english")) {
        window.open(
          "https://www.ksol.co.uk/contents/uploads/papers/11Technical%20English%20Practice%20Paper.pdf",
          "_blank",
          "noopener noreferrer"
        );
      }
    }
  };

  const findExamType = () => {
    const quizData = testData?.[index];
    // Get title from quizData or from props, with fallback
    let quizTitle = '';
    if (quizData) {
      quizTitle = getProperty(quizData, 'quizTitle') || getProperty(quizData, 'QuizTitle') || quizData?.QuizTitle || quizData?.quizTitle || '';
    }
    if (!quizTitle) {
      quizTitle = title || '';
    }
    const titleLower = typeof quizTitle === 'string' ? quizTitle.toLowerCase() : '';
    
    if (titleLower && titleLower.includes("maths")) {
      return mathsImage;
    } else if (titleLower && titleLower.includes("english")) {
      return englishImage;
    } else if (titleLower && titleLower.includes("nvr")) {
      return NVRImage;
    } else if (titleLower && titleLower.includes("verbal")) {
      return VRImage;
    } else {
      return testImage;
    }
  };

  const combinedClassName = `w-full flex flex-col items-center text-center justify-between h-full ${className}`;

  const combinedTestPaperClassName = `w-full flex flex-col items-center text-center justify-between h-full ${getTestPaperColors()}`;

  if (freePapers) {
    return (
      <div className="flex items-stretch w-full gap-4 mb-4 flex-wrap xl:flex-nowrap">
        <div
          className={
            isGcse
              ? "w-full flex flex-col items-center text-center justify-between h-full gcseBox"
              : combinedTestPaperClassName
          }
        >
          <img
            src={paperImg}
            alt="test paper"
            className="xl:w-2/4 w-1/5 shadow-md rounded-3xl mt-4"
          />
          <p className="text-left font-bold mb-4 p-4">{title}</p>

          <div className="mb-4">
            <CustomButton
              type={isMobile ? "logOut" : "testPage"}
              text="Download 11+ Papers"
              isGcse={isGcse}
              onClick={() => getTestPaperLinks()}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-stretch w-full gap-4 mb-4 flex-wrap xl:flex-nowrap">
      <div
        className={
          isGcse
            ? "w-full flex flex-col items-center text-center justify-between h-full gcseBox"
            : combinedClassName
        }
      >
        <h3 className=" p-4 font-bold ">{title}</h3>

        {testProgress === "finished" && (
          <>
            <div className="w-2/5 xl:w-3/5">
              <div className="flex mb-4 items-center ">
                <Pie data={pieData} />
              </div>
            </div>
            <div className=" flex flex-wrap xl:flex-nowrap items-center xl:ml-0 mr-auto justify-center pb-4 w-full xl:flex-row">
              <div className="flex justify-center gap-2 w-auto xl:w-full mb-4 xl:mb-0">
                <div className="green-circle"></div>
                <p className="text-center xl:text-left">Correct</p>
              </div>
              <div className="flex justify-center gap-2 w-auto xl:w-full mb-4 xl:mb-0 ">
                <div className="ml-2  red-circle"></div>
                <p className="xl:text-left">Incorrect</p>
              </div>
              <div className="flex justify-center gap-2 w-auto xl:w-full mb-4 xl:mb-0 ">
                <div className="ml-2 yellow-circle"></div>
                <p className="xl:text-left">Passed</p>
              </div>
            </div>
          </>
        )}
        {testProgress === "notStarted" && (
          <img
            src={findExamType()}
            alt="test paper"
            className="w-2/5 xl:w-3/5 h-auto rounded-3xl mb-4"
          />
        )}
        {testProgress === "inProgress" && newPercent !== undefined && (
          <div className="w-2/5 xl:w-3/5 mb-10">
            <ChangingProgressProvider values={[0, newPercent]}>
              {(percentage) => (
                <CircularProgressbar
                  value={percentage}
                  text={`${percentage}%`}
                  styles={buildStyles({
                    pathColor: "#9fd066",
                    trailColor: "#d6d6d6",
                    textColor: "#000",
                    textSize: "16px",
                    pathTransition:
                      percentage === 0
                        ? "none"
                        : "stroke-dashoffset 0.5s ease 0s",
                  })}
                  textStyle={{
                    fontFamily: "sofia-pro-soft",
                  }}
                />
              )}
            </ChangingProgressProvider>
          </div>
        )}

        <div className="mb-4">
          <CustomButton
            type={isMobile ? "logOut" : "testPage"}
            completePercent={testProgress}
            text={buttonText}
            onClick={() => whichScreen(index)}
            isGcse={isGcse}
          />
        </div>
      </div>
    </div>
  );
};

export default TestBox;
